module.exports = __webpack_public_path__ + "img/map1.eb75faa9.png";